import { render } from "./QuestionBankDetails.vue?vue&type=template&id=4822e8a2&scoped=true"
import script from "./QuestionBankDetails.vue?vue&type=script&lang=js"
export * from "./QuestionBankDetails.vue?vue&type=script&lang=js"

import "./QuestionBankDetails.vue?vue&type=style&index=0&id=4822e8a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4822e8a2"]])

export default __exports__